import { useScroll, Scroll, Text, Image } from '@react-three/drei';
import ContactForm3D from './ContactForm3D';
import { useState, useRef, useEffect, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { useModal } from './ModalContext';
import { UpsideDownModal, WhatIBringModal } from './modals';

export default function IntroText(props) {
    const { openModal, isPrewarm } = useModal();
    const [visible, setVisible] = useState(false);
    const [tableBtnHover, setTableBtnHover] = useState(false);
    const [logs, setLogs] = useState(0);
    const [currentSlide, setCurrentSlide] = useState(0);
    const scrollData = useScroll();
    const scrollPoints = useMemo(() => [18, 19, 20, 29, 31, 32, 33, 40, 42, 43, 44, 45, 47, 
         //education
         60, 63, 65, 67, 70, 
         //hobbies
         81, 99, 99], []);
    const [opacity, setOpacity] = useState(Array(19).fill(0));
    const marqueeRef = useRef();
    const mouseElRef = useRef(null);
    const mouseFadedRef = useRef(undefined);

    const textContents = [
        "holy smokes, what a match!",
        "anyway, hi — i’m nauman.",
        "welcome to my junkyard or, more accurately, my playground. a strange little corner of the internet that carries the many bits and bytes of me.",
        "i like to think of myself as a creative technologist — someone who blurs the lines between design, art, code, and play.",
        "my design approach leans on constraint, engaging narratives, and fun mechanics. for me, ambiguity and indirect storytelling spark curiosity, imagination, and mystery.",
        "most nights, after dinner, you’ll find me making games. small ideas, weird ideas, sometimes even decent ones.",
        "all i need is a cup of java (that's nerd speak for: i have a coffee dependency)",
        'by day, i’m a game designer in toronto, building tiny worlds inside mobile MMOs and deep strategy games.',
        'from early ideation to polished production, i help make spaceships roar, robots rumble, and spreadsheets... sparkle.',
        'here\'s some stuff i recently worked on:',
        'speaking of robots, i did a PhD in designing motivational games for post-stroke robot-mediated upper-limb rehabilitation.',
        '(phew)',
        'here! read my thesis',
        'tl;dr? here’s a short summary: my research explored how game design can make stroke rehabilitation more engaging through games. by applying mechanics like feedback, progression, and rewards, i showed how play can motivate patients to practice difficult movements.',
        'too nerdy? alright, let\'s stop.',
        'when i\'m not making games or playing games, you\'ll find me drawing or diving into mostly (unhinged) projects like embedding leds into my old tshirts or making this website',
        'if you’re looking for a game designer who blends systems thinking with a bit of chaos or just want to talk about weird mechanics. get in touch!',
        'that\'s it!'
    ];

    const sliderContent = [
        {
            image: './Textures/spec.png',
            heading: 'Write Documentation',
            description: 'Making design docs that don’t put you to sleep. Here’s one where I turned a messy feature idea into something readable, buildable, and iteration-ready.',
            link: 'https://docs.google.com/document/d/1q1yxG0rqNZi7XnneEu_4tE-HspMgYKlfuc_oruOdBYQ/edit?tab=t.0'
        },
        {
            image: './Textures/combatsim.png',
            heading: 'Make Kickass Spreadsheets',
            description: 'Here\'s a combat simulator spreadsheet I made to rapidly tweak and test battle variables in LOTR: Rise to War.',
            link: 'https://docs.google.com/spreadsheets/d/17EEU5bTFlDaz8FBaP_6ujxTm6-vLe01aTKmlbMTGwR0/edit?gid=1444208808#gid=1444208808'
        },
        {
            image: './Textures/funcontent.png',
            heading: 'Design Fun Content ',
            description: 'Here\'s a concept list of unique tools, weapons, and outfits I ideated for multiple factions in the Mafia Game.',
            link: 'https://docs.google.com/spreadsheets/d/10tYD5dKO2-cjy12hNxVl1gm88p-lt065fzp2h_DNQu8/edit?usp=sharing'
        },
        {
            image: './Textures/mafiascript.png',
            heading: 'Narrative Design',
            description: 'Here\'s a narrative intro & tutorial I wrote guiding players through their first heist in the Mafia Game.',
            link: 'https://docs.google.com/document/d/1Nl_KExnxZXNZ2FGGYvnMMOfucMQA3gE7CBtCVYlcWL0/edit?tab=t.0'
        },
    ];

    const toolLogos = useMemo(() => [
        './Textures/Tools/unity.png',
        './Textures/Tools/unreal.png',
        './Textures/Tools/googlesheets.png',
        './Textures/Tools/figma.png',
        './Textures/Tools/photoshop.png',
        './Textures/Tools/jira.png',
        './Textures/Tools/confluence.png',
        './Textures/Tools/miro.png'
    ], []);
    const marqueeLogos = useMemo(() => [...toolLogos, ...toolLogos], [toolLogos]);

useEffect(() => {
    if (logs === 1)
       console.log("Dude, you're such a nerd! Why are you inspecting the console when the action is all on the screen?")
    if (logs === 2)
       console.log("Ah, back for more, huh? Still not convinced there's nothing here?")
    if (logs === 3)
       console.log("Omg, you're still here? Well, spoiler alert: the cake is a lie!")
    if (logs === 4)
       console.log("Okay, you're a curious one, aren't you? Don't you have a website to look at?")
    if (logs === 5)
       console.log("You're really digging deep, huh? Looking for cheat codes? This isn't a 90s video game!")
    if (logs === 6)
       console.log("Hey, while you're here, can you check if I left any debug logs? K, thanks.")
    if (logs === 7)
       console.log("Do you always go snooping around people's consoles on the first visit? No wonder you're single.")
    if (logs === 8)
       console.log("Is this your idea of hacking? Dude, Mr. Robot you ain't.")
    if (logs === 9)
       console.log("Aha! Caught you red-handed! Now, go look at my website or else I'll unleash infinite alert boxes!")
    if (logs === 10)
       console.log("Seriously? Still here? You must be really fun at parties. Looking for party codes, are you?")
    if (logs === 11)
       console.log("You've reached the end of the console! Claim your prize of... absolutely nothing! Now go back and enjoy the actual game!")
  }, [logs]);

    useFrame((state, delta) => {
        if (state.clock.elapsedTime > 20) setLogs(1);
        if (state.clock.elapsedTime > 30) setLogs(2);
        if (state.clock.elapsedTime > 45) setLogs(3);
        if (state.clock.elapsedTime > 60) setLogs(4);
        if (state.clock.elapsedTime > 70) setLogs(5);
        if (state.clock.elapsedTime > 90) setLogs(6);
        if (state.clock.elapsedTime > 120) setLogs(7);
        if (state.clock.elapsedTime > 180) setLogs(8);
        if (state.clock.elapsedTime > 220) setLogs(9);
        if (state.clock.elapsedTime > 250) setLogs(10);
        if (state.clock.elapsedTime > 300) setLogs(11);

        // Guard: during first modal open/close some browsers may emit a transient offset glitch,
        // clamp and smooth the value to avoid desync with background planes
        const r01 = Math.min(1, Math.max(0, scrollData.range(0, 1)));
        setVisible(r01 > 0.02);

        const newOpacities = opacity.map((currentOpacity, index) => {
            if (!scrollPoints[index]) return currentOpacity;

            const offset = 4;
            const scrollPercentage = r01 * 100;
            const point = scrollPoints[index];
            let newOpacity = currentOpacity;

            if (scrollPercentage >= point - offset && scrollPercentage <= point + offset) {
                if (currentOpacity < 1) {
                    newOpacity = Math.min(1, currentOpacity + 0.07);
                }
            } else {
                if (currentOpacity > 0) {
                    newOpacity = Math.max(0, currentOpacity - 0.07);
                }
            }
            return newOpacity;
        });

        let changed = false;
        for (let i = 0; i < newOpacities.length; i++) {
            if (newOpacities[i] !== opacity[i]) { changed = true; break; }
        }
        if (changed) setOpacity(newOpacities);

        if (marqueeRef.current) {
            const spacing = 3;
            const marqueeWidth = toolLogos.length * spacing;
            marqueeRef.current.position.x -= 0.02;
            if (marqueeRef.current.position.x < -marqueeWidth) {
                marqueeRef.current.position.x += marqueeWidth;
            }
        }

        const shouldFade = scrollData.range(0, 1) > 0.01;
        if (mouseFadedRef.current !== shouldFade) {
            if (!mouseElRef.current) mouseElRef.current = document.getElementById("mouse");
            const element = mouseElRef.current;
            if (element) {
                if (shouldFade) {
                    element.classList.remove("unfade");
                    element.classList.add("fade");
                } else {
                    element.classList.remove("fade");
                    element.classList.add("unfade");
                }
            }
            mouseFadedRef.current = shouldFade;
        }
    });

    const [leftMargin, setLeftMargin] = useState(-6);
    const [baseMaxWidth, setBaseMaxWidth] = useState(10);
    const [baseFontSize, setBaseFontSize] = useState(0.5);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 780) {
                setLeftMargin(-5);
                setBaseMaxWidth(8);
                setBaseFontSize(0.46);
            } else {
                setLeftMargin(-6);
                setBaseMaxWidth(10);
                setBaseFontSize(0.5);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const textStyles = useMemo(() => ({
        font: "/Fonts/roc-grotesk-regular.otf",
        fontSize: baseFontSize,
        maxWidth: baseMaxWidth,
        lineHeight: 1.2,
        textAlign: 'left',
        anchorX: "left",
        anchorY: "middle"
    }), [baseFontSize, baseMaxWidth]);

    // Rounded button geometries
    const buttonGeometries = useMemo(() => {
        const makeRounded = (w, h, r) => {
            const x = -w / 2;
            const y = -h / 2;
            const shape = new THREE.Shape();
            shape.moveTo(x + r, y);
            shape.lineTo(x + w - r, y);
            shape.quadraticCurveTo(x + w, y, x + w, y + r);
            shape.lineTo(x + w, y + h - r);
            shape.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
            shape.lineTo(x + r, y + h);
            shape.quadraticCurveTo(x, y + h, x, y + h - r);
            shape.lineTo(x, y + r);
            shape.quadraticCurveTo(x, y, x + r, y);
            return shape;
        };
        const width = 7.0;
        const height = 1.1;
        const radius = 0.55;
        const borderDelta = 0.02; // thin outline
        const bg = new THREE.ShapeGeometry(makeRounded(width, height, radius), 8);
        const border = new THREE.ShapeGeometry(makeRounded(width + borderDelta, height + borderDelta, radius + borderDelta), 8);
        const shadow = new THREE.ShapeGeometry(makeRounded(width, height, radius), 8);
        return { bg, border, shadow };
    }, []);

    return <>
<group>
            <Scroll>
                <Text {...textStyles} position={[leftMargin, -5, 38.1]}>
                    {textContents[0]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0x386b42} opacity={opacity[0]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin, -9, 38.1]}>
                    {textContents[1]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0x386b42} opacity={opacity[1]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin, -14, 38.1]} maxWidth={8}>
                    {textContents[2]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0x386b42} opacity={opacity[2]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin-1, -25, 35.1]} maxWidth={8}>
                    {textContents[3]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xd2385a} opacity={opacity[3]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin-1, -29, 35.1]} maxWidth={8}>
                    {textContents[4]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xd2385a} opacity={opacity[4]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin-1, -33, 35.1]} maxWidth={8}>
                    {textContents[5]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xd2385a} opacity={opacity[5]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin-1, -36.5, 35.1]} maxWidth={8}>
                    {textContents[6]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xd2385a} opacity={opacity[6]} transparent />
                </Text>
                {/* Coffee dependency button */}
                {opacity[6] > 0 && (
                <group position={[leftMargin+2.4, -38.5, 35.1]}
                    onClick={() => openModal(<UpsideDownModal />)}
                    onPointerOver={() => { setTableBtnHover(true); document.body.style.cursor = 'pointer' }}
                    onPointerOut={() => { setTableBtnHover(false); document.body.style.cursor = 'auto' }}
                >
                                        {/* Soft drop shadow */}
                    <mesh position={[0.08, -0.6, -0.04]} scale={tableBtnHover ? 1.02 : 1}>
                        <primitive object={buttonGeometries.shadow} />
                        <meshBasicMaterial color={0x000000} transparent opacity={0.35} />
                    </mesh>
                    {/* Button border (thin) */}
                    <mesh position={[0, -0.5, -0.03]} scale={tableBtnHover ? 1.02 : 1}>
                        <primitive object={buttonGeometries.border} />
                        <meshBasicMaterial color={0x2b2b2b} />
                    </mesh>
                    {/* Button background with rounded corners */}
                    <mesh position={[0, -0.5, -0.02]} scale={tableBtnHover ? [1.02, 0.95, 1.02] : [1.0, 0.90, 1.0]}>
                        <primitive object={buttonGeometries.bg} />
                        <meshBasicMaterial color={tableBtnHover ? 0xfffdb8 : 0xf2ef96} />
                    </mesh>
                    {/* Button label (smaller, lowercase) */}
                    <Text
                        position={[0, -0.5, 0]}
                        fontSize={0.4}
                        anchorX="center"
                        font="/Fonts/roc-grotesk-regular.otf"
                    >
                        {'here\'s an example'}
                        <meshStandardMaterial attach="material" color={0x000000} opacity={1} transparent />
                    </Text>
                </group>
                )}
                <Text {...textStyles} position={[leftMargin-1, -46, 35.1]} maxWidth={7}>
                    {textContents[7]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[7]} transparent />
                </Text>
                <Text {...textStyles} position={[leftMargin-1, -49, 35.1]} maxWidth={7}>
                    {textContents[8]}
                    <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[8]} transparent />
                </Text>

            {/* New Work Section */}
                <group position={[leftMargin+1, -53, 35.1]} visible={opacity[9] > 0}>
                <Text
                        fontSize={0.5}
                        position={[-2, 1.6, 0]}
                    anchorX="left"
                    anchorY="top"
                    maxWidth={8}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                        {textContents[9]}
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[9]} transparent />
                </Text>
                
                {/* War of Nova Icon */}
                <Image 
                    url="./Textures/warofnova.png"
                    scale={1.5}
                    position={[-1.2, -1.8, 0]}
                        opacity={opacity[10]}
                    transparent
                />
                
                <Text 
                    fontSize={0.6}
                    position={[0, -1, 0]}
                    anchorX="left"
                    anchorY="top"
                    maxWidth={8}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                    War of Nova
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[10]} transparent />
                </Text>
                
                <Text
                    fontSize={0.3}
                    position={[0, -1.9, 0]}
                    anchorX="left"
                    anchorY="top"
                        maxWidth={6}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                        Web3 4X strategy game with space fleets, resource wars, and political dominance.
                        I helped design core systems: combat, progression, and economy.    
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[10]} transparent />
                </Text>
                
                <Text
                    fontSize={0.4}
                        position={[0, -4.1, 0]}
                    anchorX="left"
                    anchorY="top"
                        maxWidth={6}
                        onPointerOver={(e) => { document.body.style.cursor = 'pointer'; }}
                        onPointerOut={(e) => { document.body.style.cursor = 'auto'; }}
                    onClick={() => window.open('https://warofnova.com/', '_blank')}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                    play now
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[10]} transparent />
                </Text>
                    
                    <mesh position={[0.8, -4.6, 0]} visible={opacity[10] > 0}>
                        <planeGeometry args={[1.6, 0.02]} />
                    <meshBasicMaterial 
                        color={props.darkMode ? 0xffffff : 0xffffff} 
                        transparent 
                            opacity={opacity[10]}
                    />
                    </mesh>
                
                {/* HatchKings Icon */}
                <Image 
                    url="./Textures/hatchkings.png"
                    scale={1.5}
                        position={[-1.2, -6.0, 0]}
                        opacity={opacity[11]}
                    transparent
                />
                
                <Text
                    fontSize={0.6}
                        position={[0, -5.2, 0]}
                    anchorX="left"
                    anchorY="top"
                        maxWidth={6}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                    HatchKings
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[11]} transparent />
                </Text>
                
                <Text
                    fontSize={0.3}
                        position={[0, -6.0, 0]}
                    anchorX="left"
                    anchorY="top"
                        maxWidth={6}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                    Casual dragon collectible with seasonal content and a competitive egg-hatching economy.
                        I handled some of the content design, balancing, and UX flows
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[11]} transparent />
                </Text>
                
                <Text
                    fontSize={0.4}
                        position={[0, -7.8, 0]}
                    anchorX="left"
                    anchorY="top"
                    maxWidth={8}
                        onPointerOver={(e) => { document.body.style.cursor = 'pointer'; }}
                        onPointerOut={(e) => { document.body.style.cursor = 'auto'; }}
                    onClick={() => window.open('https://hatchkings.revolvinggames.com/?cache=false', '_blank')}
                    font="/Fonts/roc-grotesk-regular.otf"
                >
                    play now
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xffffff} opacity={opacity[11]} transparent />
                    </Text>
                   
                    <mesh position={[0.8, -8.31, 0]} visible={opacity[10] > 0}>
                        <planeGeometry args={[1.6, 0.02]} />
                        <meshBasicMaterial
                            color={props.darkMode ? 0xffffff : 0xffffff}
                            transparent
                            opacity={opacity[11]}
                        />
                    </mesh>

                    
                </group>

                {/* What I Bring to the Table button */}
                <group position={[leftMargin+4, -66, 35.1]} visible={opacity[12] > 0}
                    onClick={() => openModal(<WhatIBringModal />)}
                    onPointerOver={() => { setTableBtnHover(true); document.body.style.cursor = 'pointer' }}
                    onPointerOut={() => { setTableBtnHover(false); document.body.style.cursor = 'auto' }}
                >

                    <Text
                        fontSize={0.5}
                        position={[leftMargin+1, 1.6, 0]}
                        anchorX="left"
                        anchorY="top"
                        maxWidth={8}
                        font="/Fonts/roc-grotesk-regular.otf"
                    >
                        {"a quick look at what I bring to the table."}
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xe2e2e2} opacity={opacity[12]} transparent />
                    </Text>
                    
                    {/* Soft drop shadow */}
                    <mesh position={[leftMargin+5, -2.05, -0.04]} scale={tableBtnHover ? 1.02 : 1}>
                        <primitive object={buttonGeometries.shadow} />
                        <meshBasicMaterial color={0x000000} transparent opacity={0.35} />
                    </mesh>
                    {/* Button border (thin) */}
                    <mesh position={[leftMargin+5, -2, -0.03]} scale={tableBtnHover ? 1.02 : 1}>
                        <primitive object={buttonGeometries.border} />
                        <meshBasicMaterial color={0x2b2b2b} />
                    </mesh>
                    {/* Button background with rounded corners */}
                    <mesh position={[leftMargin+5, -2, -0.02]} scale={tableBtnHover ? [1.02, 0.95, 1.02] : [1.0, 0.90, 1.0]}>
                        <primitive object={buttonGeometries.bg} />
                        <meshBasicMaterial color={tableBtnHover ? 0xfffdb8 : 0xf2ef96} />
                    </mesh>
                    {/* Button label (smaller, lowercase) */}
                    <Text
                        position={[leftMargin+5, -2.0, 0]}
                        fontSize={0.4}
                        anchorX="center"
                        font="/Fonts/roc-grotesk-regular.otf"
                    >
                        {'sneak a peek'}
                        <meshStandardMaterial attach="material" color={0x000000} opacity={opacity[12]} transparent />
                    </Text>
                </group>

                {/* Tools Marquee Section
                <group position={[leftMargin +4, -74, 35.1]} visible={opacity[9] > 0}>
                    <Text
                        position={[-1.5, 1, 0]}
                        fontSize={0.6}
                        anchorX="center"
                        font="/Fonts/roc-grotesk-regular.otf"
                    >
                        {'Tools I Use'}
                        <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xe2e2e2} opacity={opacity[9]} transparent />
                    </Text>
                    <group ref={marqueeRef}>
                        {[...toolLogos, ...toolLogos].map((logo, index) => (
                            <Image key={index} url={logo} position={[index * 3, -1, 0]} scale={1} opacity={opacity[9]} transparent />
                        ))}
                    </group>
                </group> */}

                 <Text {...textStyles} position={[leftMargin, -84, 35.1]} maxWidth={8}>
                     {textContents[10]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xfbecc9} opacity={opacity[13]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin, -88, 35.1]} maxWidth={8}>
                     {textContents[11]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xfbecc9} opacity={opacity[14]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin, -92, 35.1]} maxWidth={8}>
                     {textContents[12]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xfbecc9} opacity={opacity[15]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin, -97, 35.1]} maxWidth={8}>
                     {textContents[13]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xfbecc9} opacity={opacity[16]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin, -104, 35.1]} maxWidth={6}>
                     {textContents[14]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0xfbecc9} opacity={opacity[17]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin-0.5, -125, 35.1]} maxWidth={8}>
                     {textContents[15]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0xffffff : 0xf9ff4b} opacity={opacity[18]} transparent />
                 </Text>
                 <Text {...textStyles} position={[leftMargin, -156, 35.1]} maxWidth={10}>
                     {textContents[16]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0x195787} opacity={opacity[19]} transparent />
                 </Text>

            {/* 3D Contact Form */}
            <ContactForm3D 
                darkMode={props.darkMode}
                opacity={1}
                position={[0, -163, 35.1]}
                onActiveFieldChange={props.onActiveFieldChange}
            />

            <Text {...textStyles} position={[0, -180, 35.1]}>
                     {textContents[16]}
                     <meshStandardMaterial attach="material" color={props.darkMode ? 0x1a1a1a : 0x195787} opacity={opacity[20]} transparent />
                 </Text>
        </Scroll>
    </group>
</>
}